import { defineMessages } from 'react-intl';

const messages = defineMessages({
  formTitle: { id: 'modules-default-landingReferral-formTitle' },
  formSubtitle: { id: 'modules-default-landingReferral-formSubtitle' },
  rules: { id: 'modules-default-landingReferral-rules' },
  rulesLink: { id: 'modules-default-landingReferral-rules-link' },
  submit: { id: 'modules-default-landingReferral-submit' },
  labelName: { id: 'modules-default-landingReferral-labelName' },
  labelSurname: { id: 'modules-default-landingReferral-labelSurname' },
  labelEmail: { id: 'modules-default-landingReferral-labelEmail' },
  labelTelephone: { id: 'modules-default-landingReferral-labelTelephone' },
  consulting: { id: 'modules-default-landingReferral-labelConsulting' },
  newsletter: { id: 'modules-default-landingReferral-labelNewsletter' },
  others: { id: 'modules-default-landingReferral-labelOthers' },
  comment: { id: 'modules-default-landingReferral-comment' },
  formSubmitSuccess: { id: 'modules-default-landingReferral-formSubmitSuccess' },
});

export default messages;
